import type { StockScanInput, StockScanRoute } from '@/domains/command-center/handlers/stock/stockMode.types'

/**
 * What a scan means in stock mode.
 *
 * - The item being counted again adds one.
 * - The item being counted, while its save is on the way, is held and opens next. Its number has left the box.
 * - A different item, while a number waits to be saved, is held and opens next.
 * - A code naming exactly one variant counts it, starting at one.
 * - Any other code lists what it finds, or that it finds nothing.
 */
const routeScan = ({ code, matches, countingVariantId, hasQuantity, isSaving }: StockScanInput): StockScanRoute => {
  const single = matches.length === 1 ? matches[0] : null

  if (countingVariantId !== null && single?.id === countingVariantId) {
    return isSaving ? { kind: 'hold', held: { code, variant: single } } : { kind: 'countAgain' }
  }

  if (countingVariantId !== null && hasQuantity) return { kind: 'hold', held: { code, variant: single } }

  if (single) return { kind: 'count', variant: single }

  return { kind: 'search', code }
}

export { routeScan }
